import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bzykasyg9b: FaireBrandEntity = {
  token: "b_bzykasyg9b",
  type: "brand",
  name: "Artistry Candies, LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/c0af849ceb0a9275cd6d709fcfd75bb24b79b7644f479f72eab96bd180a627d2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a5aa8c86c950bdb5b467ece9d5b2da4903c0fe02723074c32839b5379531849b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c0af849ceb0a9275cd6d709fcfd75bb24b79b7644f479f72eab96bd180a627d2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a5aa8c86c950bdb5b467ece9d5b2da4903c0fe02723074c32839b5379531849b.jpeg",
  location: "Cumming, GA, USA",
  minimumOrderDollars: 137,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Tammy Varela is a cake and candy artist based in Cumming, GA. She founded Artistry Candies in 2025 after discovering a true passion for working with sugar. A former cake artist, Tammy has won several awards in cake competitions, including the Rising Star USA Award at the ACAs in 2023. She has also competed on multiple Food Network shows, including Halloween Wars. Tammy is excited to continue growing her candy business and looks forward to what the future holds.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:20.919Z",
    importedBy: "entity-db-cli",
  },
};
